export default __webpack_public_path__ + "static/media/Match-start.80389afc.mp3";